import ApiClient from "../api/apiClient";

const GET_SESSION_ID = "/payment/sessions";
const PAYMENT = "/payment";
const PAYMENT_STATUS_FOR_ENDORSEMENT = "/payment/get-payment";

const getSessionID = ({ data }) => {
  return ApiClient.post(GET_SESSION_ID, data);
};

const updatePaymentStatus = ({ data }) => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return ApiClient.post(PAYMENT, data, { headers: { 'timeZone': timeZone}});
};

const getPaymentHistory = () => {
  return ApiClient.get(PAYMENT);
};

const paymentStatus = () => {
  return ApiClient.get(PAYMENT_STATUS_FOR_ENDORSEMENT);
}

export const paymentService = {
  getSessionID,
  updatePaymentStatus,
  getPaymentHistory,
  paymentStatus,
};
